/**
 *  @type {{[key: string]: import('$lib/utils/page').PageCondition}} conditions - The conditions object containing the conditions to be resolved.
 */
const pageConditions = {
	resendLink: {
		condition: async () => {
			const url = new URL(window.location.href);
			const variant = url.searchParams.get('variant');
			// 'resend' is set by inbound-gateway for any expired braze token.
			// 'reactivation' is the legacy value set by the reactivation policy exception handler.
			return variant === 'reactivation' || variant === 'resend';
		},
		resolve: async () => await import('../_browser-expired-link-resend/Page.svelte'),
	},
	default: {
		condition: async () => true,
		resolve: async () => await import('../_browser/Page.svelte'),
	},
};

export { pageConditions };
